import { makeInflect } from "../../../../core/utils/makeInflect.js";

export const inflectStandingPhoto = makeInflect("stojící obrázek", "stojící obrázky", "stojících obrázků");
